import React, { useEffect, useRef, useState } from 'react';
import './Product.css';

const BoiteExpedition = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const galleryImages = [
    '/images/boites_d_expedition/1.jpg',
    '/images/boites_d_expedition/2.jpg',
    '/images/boites_d_expedition/3.jpg',
    // '/images/boites_d_expedition/4.jpg',
    // '/images/boites_d_expedition/5.jpg',
    // '/images/boites_d_expedition/6.jpg',
    // '/images/boites_d_expedition/7.jpg',
    // '/images/boites_d_expedition/8.jpg',
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="product" ref={sectionRef}>
      <div className="product-container">
        <div className="product-layout">
          {/* Product Description */}
          <div className={`product-text ${isVisible ? 'fade-in' : ''}`}>
            <h2 className="product-title">Boîte produit sur mesure</h2>
            <p>
              La boîte produit sur mesure a de nombreux domaines d'application :{' '}
              <span>emballage de bougies, produits pour enfants, cosmétiques, pharmaceutiques, savons, pièces mécaniques, produits écologiques, confiseries, parfums, thé ou café, produits intimes, couteaux, pots de miel, produits féminins...</span>
            </p>
            <ul className="feature-list">
              <li>
                <span className="tick">✔</span> Le packaging idéal pour{' '}
                <span>emballer vos produits à l’unité</span>. En carton ondulé pour une protection optimale et une démarche éco-responsable.
              </li>
              <li>
                <span className="tick">✔</span> De conception astucieuse et facile à monter, il ne nécessite ni colle, ni adhésif, grâce à sa patte de fermeture.
              </li>
              <li>
                <span className="tick">✔</span> Grâce à sa forme simple,{' '}
                <span>il épouse au mieux votre produit</span>, qu’il soit petit ou allongé, ou même de format XXL.
              </li>
              <li>
                <span className="tick">✔</span> Entièrement personnalisable, il devient une vitrine pour vos produits, qui peuvent être exposés en boutique ou envoyés chez vos clients.{' '}
                <span>Choisissez une version blanche ou naturelle</span> selon l’image que vous souhaitez renvoyer.
              </li>
              <li>
                <span className="tick">✔</span> Sur-mesure, il peut être pensé pour de nombreuses utilisations : petit, il se fait emballage de bougies ; allongé, il devient fourreau pour vos affiches ; couché, il est un écrin pour vos produits fragiles…
              </li>
              <li>
                <span className="tick">✔</span> Avec nos minimums de commandes les plus bas du marché, et grâce au sur-mesure,{' '}
                <span>vous pouvez créer un emballage unique</span> pour chacun de vos produits, renvoyant une image très professionnelle et qualitative.
              </li>
            </ul>
          </div>

          {/* Image Gallery */}
          <div className={`product-gallery ${isVisible ? 'fade-in-delay' : ''}`}>
            <div className="gallery-grid">
              {galleryImages.map((image, index) => (
                <div key={index} className="gallery-item">
                  <img src={image} alt={`Coffret à oreilles ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoiteExpedition;